export default __webpack_public_path__ + "static/media/sroubovak.ba0694f5.png";